import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { appConfig } from 'src/environments/enviroment';

@Injectable({
  providedIn: 'root',
})
export class EncryptDecryptService {
  // Methods for the encrypt and decrypt Using AES
  encryptUsingAES256(data: any): string {
    try {
      if (!data) {
        throw new Error('Invalid input: Data is missing or empty.');
      }

      const key = CryptoJS.enc.Utf8.parse(appConfig.EncryptKey); // Ensure 16-byte key
      const iv = CryptoJS.enc.Utf8.parse(appConfig.EncryptIV); // Ensure 16-byte IV

      const encrypted = CryptoJS.AES.encrypt(JSON.stringify(data), key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      });

      return encrypted.toString(); // Return base64-encoded ciphertext
    } catch (error) {
      console.error('Encryption error:', error);
      sessionStorage.clear();
      window.location.reload();
      return ''; // Handle the error appropriately
    }
  }

  decryptUsingAES256(decString: any): string {
    try {
      if (!decString || typeof decString !== 'string') {
        throw new Error(
          'Invalid input: Encrypted string is missing or incorrect.',
        );
      }

      let encryptedData;
      try {
        encryptedData = JSON.parse(decString);
      } catch (e) {
        encryptedData = decString; // If it's not JSON, use as-is
      }

      const key = CryptoJS.enc.Utf8.parse(appConfig.EncryptKey); // Ensure 16-byte key
      const iv = CryptoJS.enc.Utf8.parse(appConfig.EncryptIV); // Ensure 16-byte IV

      let decrypted = CryptoJS.AES.decrypt(encryptedData, key, {
        keySize: 128 / 8,
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      });

      let decryptedData = decrypted.toString(CryptoJS.enc.Utf8);

      if (!decryptedData) {
        throw new Error('Decryption failed: Data is empty or malformed UTF-8.');
      }

      return decryptedData;
    } catch (error) {
      console.error('Decryption error:', error);
      sessionStorage.clear();
      window.location.reload();
      return '';
    }
  }

  decodeJwtToken(token: string): any {
    try {
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      return JSON.parse(atob(base64));
    } catch (error) {
      console.error('Error decoding JWT token:', error);
      sessionStorage.clear();
      window.location.reload();
      return null;
    }
  }
}
